<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <div class="header-wrapper">
      <mat-icon style="color: red;"> info_outline </mat-icon>
      <div class="header-title">{{ "GrabMiniApp.GrabAppRequired" | translate }}</div>
    </div>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    <p>
      {{ "GrabMiniApp.OnlyInGrabApp" | translate }}
    </p>

    <p class="sub-text">
      {{ "GrabMiniApp.OpenLink" | translate }}
    </p>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button
      class="btn"
      (click)="openGrabApp()"
    >
      {{ "GrabMiniApp.OpenGrabApp" | translate }}
    </button>
  </div>

</div>